<template>
  <div class="component-container">
    <h3>MSENG2 Weather, Climate, and Human Impact - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202025%20Updates%2FMSENG2_Activities1-8_updated_08242026.zip?alt=media&token=36504df6-ea81-46b9-9931-2fe586148943" target="_blank">Activities 1-8 (Zip File) - Updated 8-24-2026</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
      </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1_IwdDdkFR4YdRkNvv_BWoXcoLdu57OV1eRPHZ_iO28A/copy" target="_blank">MSENG2 Weather, Climate, and Human Impact Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1cYaWX8Ax-8KNosVs0BNA7d2xu9ILA9QP/view" target="_blank">MSENG2 Weather, Climate, and Human Impact Student Journal Answer Key</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make classroom copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1JxUwigQizBOQlG9fh-He0x6OQMFbY8z0KoccXNT-o1c/copy" target="_blank">Lesson 1A - Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Dj2Q-ZbOaFv9K8x8RnkBc6G6hI9rs5JHmJ6EH_bxy6E/copy" target="_blank">Lesson 1A - What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1I30-uEqvXUcmhI5A8lR2P66Q8Jtq-TPg-iiOoKWpAAI/copy" target="_blank">Lesson 1B - Daily Weather Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1O0iyzAA3dEwdf17BYWPsAbpllpLHBoFH74jXenhHSQM/copy" target="_blank">Lesson 2A - Gases of the Atmosphere card set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1P-cbcrmqBSzWLQ2h7TG5vZ5giMJhxbXcZcsPjtXPVgw/copy" target="_blank">Lesson 3A - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1lMy8mrbt2T4vjNFKjAsqrWHbQMvNFbdt73jp8gqaMR0/copy" target="_blank">Lesson 3B - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/158Ll300DjAUCK9PQthFm1cFgxT5R6wRpDs6IHZ1PckM/copy" target="_blank">Lesson 4B - Weather Front Picture Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1xzvuY01lnRi5JYJCXJU3wm9jAR3EztMrWW9ZiQPEEnY/copy" target="_blank">Lesson 5B - Formation of Precipitation Pre-writing Think Sheet</a></li>
          <li><a href="https://docs.google.com/presentation/d/1D910BA73YUtKYHIMegdqmWY4v5bAS5_Q-OBHSBhIV8w/copy" target="_blank">Lesson 6A - Water Cycle Poster</a></li>
          <li><a href="https://drive.google.com/file/d/18DiHwAbiuqYWkGL_K0DFiM_xZIX4tTNX/view?usp=sharing" target="_blank">Lesson 6B - Engineering Design Process (PDF)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Sg4TfmlQMTYICXDjovfKPbdoXUKcRgt91ldXk4O2_Nk/copy" target="_blank">Lesson 6C - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1yF97BcyH3WnLFcPb3RyUDjzBgE5xAGAWdtWsdc7sivI/copy" target="_blank">Lesson 7A - Weather or Climate Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1B0i07OoPsT75U3bdoiNjedun-cLMByG21EzmQ2KHFHs/copy" target="_blank">Lesson 7B - Bird Migration Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1y9hzC3I9xfvZEV0y3k6OYDUm1sJbNuZx6xuD3JOqYGg/copy" target="_blank">Lesson 7C - Note-Taking Tool for Obtaining Information from Media</a></li>
          <li><a href="https://docs.google.com/presentation/d/1SLY6N0AX1SF4Z2C5-MQCp3r7q5y0v0G_XCKl16mo_jo/copy" target="_blank">Lesson 7D - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1XsYMUscFfG1B3iNarhbb1rle_UrkE85ZMZa3BqJAKrw/copy" target="_blank">Lesson 8A - Climate Change Cards</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
